import { useRef, useState } from "react";
import { object } from "prop-types";
import { WorkTypeManager } from "@tools";
import { AddButton } from "@components";

export const HeaderWorkTypeEditor = ({
  section,
}) => {
  const [managerVisible, showManager] = useState(false);
  
  const anchor = useRef(null);
  
  return <>
    <AddButton
      onClick={() => showManager(!managerVisible)}
      ref={anchor}
      tabIndex={-1}
      name="Manage breakdown work types"
      className="noDrag mr-2"
    />
    {
      managerVisible &&
      <WorkTypeManager
        open={managerVisible}
        onClose={() => showManager(false)}
        anchorEl={anchor?.current}
        section={section}
      />
    }
  </>
}

HeaderWorkTypeEditor.propTypes = {
  section: object,
}